// src/components/dashboard/employee/CompletedTrainingsWidget.js
import React from 'react';
import { Table } from 'react-bootstrap';
import DashboardCard from '../DashboardCard';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function CompletedTrainingsWidget({ trainings, loading }) {
  return (
    <DashboardCard
      title="Recently Completed"
      icon="bi-check-circle"
      loading={loading}
      isEmpty={!loading && trainings.length === 0}
      emptyMessage="No completed trainings yet."
    >
      <Table borderless size="sm" className="mb-0 align-middle">
        <tbody>
          {trainings.map(t => (
            <tr key={t.id}>
              <td>
                <div className="fw-semibold">{t.title}</div>
                <div className="text-muted small">
                  {t.code} &middot; {t.end_date}
                  {(t.result_1 || t.result_2) && (
                    <> &middot; Result: {[t.result_1, t.result_2].filter(Boolean).join(' / ')}</>
                  )}
                </div>
                {t.certificate_id && (
                  <a
                    href={`${API_BASE_URL}/certificates/download_certificate.php?id=${t.certificate_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-primary btn-sm mt-1 me-1"
                  >
                    <i className="bi bi-award me-1"></i>
                    Download Certificate
                  </a>
                )}
                {t.competency_certificate_id && (
                  <a
                    href={`${API_BASE_URL}/certificates/download_certificate.php?id=${t.competency_certificate_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-warning btn-sm mt-1"
                  >
                    <i className="bi bi-award-fill me-1"></i>
                    Download Competency Certificate
                  </a>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </DashboardCard>
  );
}

export default CompletedTrainingsWidget;
